export const allCategory = "all"
export const newCategory = "new"
export const approvedCategory = "approved"
export const rejectedCategory = "rejected"
export const removedCategory = "removed"
